
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth",
      function () {
        return require("private-next-pages/docs/auth/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth"])
      });
    }
  